import { ObsItem, Station } from '../models'
import { client } from './client'

export type ObsQueryParams = Record<string, string | number>

export type GetObsRes = {
  metadata: { stations: Station[] }
  items: ObsItem[]
}

export const fetchObs = async (
  elmId: string,
  params: ObsQueryParams,
  timeout?: number,
) => {
  const response = await client.get<GetObsRes>(`/api/gis/${elmId}`, {
    params,
    timeout,
  })
  return response.data
}
